<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-actions">
				<div className="sf-actions__left">
					<!-- 저장 -->
					<sf-button v-if="isButton_(scrId, 'CU') && btnChk1" line size="sm" icon="file" color="info" :onClick="() => saveAction()">
						{{ getMessage_('QWCC001131') }}
					</sf-button>
					<!-- 작성 -->
					<sf-button v-if="isButton_(scrId, 'WR') && btnChk2" line size="sm" icon="file" color="info" :onClick="() => updateAction('20')">
						{{ getMessage_('QWCC000056') }}
					</sf-button>

					<!-- 검토(검토자) -->
					<sf-button v-if="isButton_(scrId, 'IP') && btnChk3" line size="sm" icon="round-check-on" :onClick="() => updateAction('30')">
						{{ getMessage_('QWCC001132') }}
					</sf-button>
					<template v-if="!isGlims">
						<!-- 회신 -->
						<sf-button v-if="isButton_(scrId, 'RP') && btnChk5" line size="sm" icon="round-check-on" :onClick="() => answerAction('40')">
							{{ getMessage_('QWCC001571') }}
						</sf-button>
						<!-- 승인(승인자) -->
						<sf-button v-if="isButton_(scrId, 'CS') && btnChk6" line size="sm" icon="round-check-on" :onClick="() => updateAction('50')">
							{{ getMessage_('QWCC001001') }}1
						</sf-button>
					</template>
					<template v-else-if="isGlims">
						<!-- 승인(승인자) -->
						<sf-button v-if="isButton_(scrId, 'CS') && btnChk6" line size="sm" icon="round-check-on" :onClick="() => updateAction('40')">
							{{ getMessage_('QWCC001001') }}2
						</sf-button>
					</template>

					<!-- 반려(승인자, 검토자) -->
					<sf-button v-if="isButton_(scrId, 'GV') && btnChk4" line size="sm" icon="circle-close" :onClick="() => updateAction('10')">
						{{ getMessage_('QWCC001573') }}
					</sf-button>
					<!-- 삭제 -->
					<sf-button v-if="isButton_(scrId, 'CD') && btnChk2" line size="sm" icon="circle-close" :onClick="() => deleteAction()">
						{{ getMessage_('QWCC001136') }}
					</sf-button>
					<!-- 개선이력 -->
					<sf-button v-if="isButton_(scrId, 'CR') && btnChk7" line size="sm" icon="circle-close" :onClick="() => historyAction()">
						{{ getMessage_('QWCC001574') }}
					</sf-button>
					<!-- 불량통보서 && detailForm.pgsStCd == 40-->
					<sf-button v-if="isButton_(scrId, 'CR') && btnChk7" line size="sm" :onClick="reportAction">
						{{ getMessage_('QWCC002018') }}
					</sf-button>
					<!-- 삭제 -->
					<!-- <sf-button line size="sm" icon="trash" color="error" :onClick="deleteAction" v-if="isButton_(scrId, 'CD')"> -->
					<!-- <sf-button line size="sm" icon="trash" color="error" :onClick="deleteAction">
						{{ getButtonMsg_(scrId, 'CD') }}
					</sf-button> -->
					<!-- 메일발송 -->
					<!-- <sf-button line size="sm" icon="round-check-on" :onClick="mailSendAction">
						{{ getMessage_('QWCC001575') }}
					</sf-button> -->
				</div>
			</div>
		</div>
		<!-- 레포트 팝업 -->
		<report-popup ref="reportPopup" :scrId="scrId"></report-popup>
	</div>
</template>

<script>
import * as Yup from 'yup';
import { utils } from '@sfaas/util';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PrtRpt/store/helpers';
import ReportPopup from '@qms/Components/popup/ReportPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		isGlims: { type: Boolean, default: false },
		flgOsGrp: { type: Boolean, default: false },
		flgPqyapGrp: { type: Boolean, default: false },
		flgPqyrvGrp: { type: Boolean, default: false },
		flgPqyrgGrp: { type: Boolean, default: false },
		flgPqycpGrp: { type: Boolean, default: false },
		flgPqypoGrp: {type: Boolean, default: false},
		flgPqylpGrp: { type: Boolean, default: false },
		flgPqyipGrp: { type: Boolean, default: false }
	},
	components: { ReportPopup },
	computed: {
		...rootComputed,
		...serviceComputed,
		isDisabled() {
			// disabled Controll
			let pass = false;
			const pgsStCd = this.detailForm.pgsStCd;
			//console.log('isDisabled pgsStCd >>> ', pgsStCd);
			if (pgsStCd != undefined && Number(pgsStCd) >= 20) {
				pass = true;
			}
			//console.log('isDisabled pass >>> ', pass);
			return pass;
		},
		btnChk1() {
			// 저장버튼 Controll
			let pass = true;
			const pgsStCd = this.detailForm.pgsStCd;
			//console.log('btnChk1 pgsStCd >>> ', pgsStCd);
			if (pgsStCd != undefined && Number(pgsStCd) > 10) {
				pass = false;
			}
			//console.log('btnChk1 pass >>> ', pass);
			return pass;
		},
		btnChk2() {
			// 작성, 삭제 버튼 Controll
			let pass = true;
			const pgsStCd = this.detailForm.pgsStCd;
			//console.log('btnChk2 pgsStCd >>> ', pgsStCd);
			if (pgsStCd != undefined && Number(pgsStCd) >= 20) {
				pass = false;
			}
			//console.log('btnChk2 pass >>> ', pass);
			return pass;
		},
		btnChk3() {
			// 검토 버튼 Controll
			let pass = true;
			const pgsStCd = this.detailForm.pgsStCd;
			//console.log('btnChk3(검토) pgsStCd >>> ', pgsStCd);
			if (pgsStCd != undefined && Number(pgsStCd) > 20) {
				pass = false;
			}
			//console.log('btnChk3(검토) pass >>> ', pass);
			return pass;
		},
		btnChk4() {
			//console.log('this.flgPqyrvGrp , flgPqyapGrp>>> ', this.flgPqyrvGrp, this.flgPqyapGrp,this.flgPqypoGrp);
			//반려버튼 제어
			let pass = false;
			const pgsStCd = this.detailForm.pgsStCd;
			if (this.flgPqyrvGrp) {
				//검토자그룹
				if (Number(pgsStCd) === 20) {
					// 검사완료 상태(20)
					pass = true;
					return pass;
				} else {
					pass = false;
				}
			}

			if (this.flgPqyapGrp) {
				//승인자그룹
				//console.log('test >>>>', this.isGlims);
				if (!this.isGlims) {
					// lp일 경우는 회신도 들어간다.
					if (Number(pgsStCd) === 40 || Number(pgsStCd) === 30) {
						// 회신완료 상태(40)
						pass = true;
						return pass;
					} else {
						pass = false;
					}
				} else {
					// kd일때
					if (Number(pgsStCd) === 30) {
						// 검토완료 상태(40)
						pass = true;
						return pass;
					} else {
						pass = false;
					}
				}
			}

			if (this.flgOsGrp) {
				pass = true;
			}
			//console.log('btnChk4 검토자(flgPqyrv), 승인자(flgPqyap), pass여부 >>>', this.flgPqyrvGrp, this.flgPqyapGrp, pass);
			return pass;
		},
		btnChk5() {
			//회신버튼 제어
			let pass = false;
			// 회신 필요 이면서, 검토 완료 단계일때
			const { pgsStCd, mdvRplCd } = this.detailForm;
			if (mdvRplCd === 'RPL10' && Number(pgsStCd) === 30) {
				pass = true;
			}
			//console.log('btnChk5 pgsStCd, mdvRplCd, pass여부 >>>', pgsStCd, mdvRplCd, pass);

			return pass;
		},
		btnChk6() {
			//승인버튼 제어
			let pass = false;
			const { pgsStCd } = this.detailForm;

			if (!this.isGlims) {
				// 회신상태일때
				if (Number(pgsStCd) === 40) {
					pass = true;
				} else {
					pass = false;
				}
			} else {
				// 검토상태일때
				if (Number(pgsStCd) === 30) {
					pass = true;
				} else {
					pass = false;
				}
			}
			//console.log('btnChk6 isGlims, pgsStCd, pass여부 >>>', this.isGlims, pgsStCd, pass);
			return pass;
		},
		btnChk7() {
			let pass = true;
			if (this.flgPqylpGrp) {
				//검토자그룹
				pass = false;
				return pass;
			}
			return pass;
		},
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		/**
		 *  저장 버튼 클릭시
		 */
		saveAction() {
			try {
				//저장 Validation 처리
				this.makeValidateSave();

				// 메일정보 입력 Validation 처리
				this.makeValidateEmailAdr();

				// 저장 전 유효성 체크
				// this.schema.validateSync(this.formInfo);
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001119'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001131'), clickFn: () => this.save() }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		async save() {
			try {
				this.$sf_toggleLoading(true);

				// 임시저장이기 때문에 상태값을 빈 값으로으로 등록
				this.onChangeParam_({ key: 'pgsStCd', value: '' });
				this.onChangeParam_({ key: 'sndStCd', value: 'NSND' }); //임시저장으로 메일코드 셋팅 : SND_ST
				//form데이터 저장
				const { code, messageCd } = await this.saveData_(this.detailFormData_);

				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				this.$emit('Refresh');
				this.$emit('Close');
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		/**
		 *  작성, 승인, 확정, 반려, 버튼 클릭시
		 */
		updateAction(btnPgsStCd) {
			try {
				// 유효성 체크
				this.makeValidatePprNo();

				this.makeValidateState(btnPgsStCd);

				this.$sf_toggleLoading(true);

				// 컨펌창 실행
				if(btnPgsStCd=='40'){
					this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001119'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001131'), clickFn: () => this.saveState2(btnPgsStCd) }] //저장
				});
				}else{
					this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001119'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001131'), clickFn: () => this.saveState(btnPgsStCd) }] //저장
				});
				}
				
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async saveState(pgsStCd) {
			this.$sf_toggleLoading(true);
			try {
				// LP일때의 승인(50) 일경우 불량원인도 수정가능해야 하기때문에 분기처리함
				if (pgsStCd === '50') {
					this.answer(pgsStCd);
				} else {
					const fData = this.detailFormData_;
					let sndStCd = fData.get('sndStCd');
					if (pgsStCd === '20') {
						sndStCd = 'NSND';
					}
					if (pgsStCd === '30') {
						sndStCd = 'NSND';
					}
					const stateParams = {
						pprNo: fData.get('pprNo'),
						partNo: fData.get('partNo'),
						affrPrcsId: fData.get('affrPrcsId'),
						pgsStCd: pgsStCd,
						bePgsStCd: fData.get('pgsStCd'),
						emlSndNo: fData.get('emlSndNo'),
						affrScnCd: fData.get('affrPrcsId'),
						sndStCd: sndStCd,
						badTitlSbc: fData.get('badTitlSbc'),
						badSbc: fData.get('badSbc'),
						dsprNm: fData.get('dsprNm'),
						dsprAdr: fData.get('dsprAdr'),
						rcptNm: fData.get('rcptNm'),
						rcptAdr: fData.get('rcptAdr'),
						rfpNm: fData.get('rfpNm'),
						rfpAdr: fData.get('rfpAdr'),
						partGCd: fData.get('partGCd'),
						rmk1: fData.get('rmk1'),
						lotFromNo: fData.get('lotFromNo'),
						lotToNo: fData.get('lotToNo'),
						clmTypeCd: fData.get('clmTypeCd'),
						tpWayCd: fData.get('tpWayCd'),
						badTypeSgrpCd: fData.get('badTypeSgrpCd'),
						badQty: fData.get('badQty'),
						badImgFileId: fData.get('badImgFileId'),
						normImgFileId: fData.get('normImgFileId'),
						badFileId: fData.get('badFileId'),
						occuPlCd: fData.get('occuPlCd'),
						badFileCnt: 0,
						abrdRprTm: fData.get('abrdRprTm'),
						clmNo: fData.get('clmNo'),
						 badCausSbc:fData.get('badCausSbc'),
						bttmMdvSbc:fData.get('bttmMdvSbc'),
						// badCausFileDb:fData.get('badCausFileDb'),
						 bttmLotNo:fData.get('bttmLotNo'),
						 mdvDd:fData.get('mdvDd'),
						 rptpPrcsCd:fData.get('rptpPrcsCd'),
						 mdvPprrNm:fData.get('mdvPprrNm'),
						 ckuNo:fData.get('ckuNo')
					};

					//console.log('***********stateParams: ', JSON.stringify(stateParams));
					const data = await this.saveState_(stateParams);
					//console.log(data);
					const msgCd = data.glimsErrMsg != undefined || data.glimsErrMsg !== '' ? data.glimsErrMsg : data.messageCd;
					if (data.code === 0 || data.code === 3) {
						this.$sf_toast({
							type: data.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(msgCd)
						});
						this.$emit('Close');
						this.$emit('Refresh');
					}
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},

		async saveState2(pgsStCd) {
			this.$sf_toggleLoading(true);
			try {
				const pprNo = this.detailForm.pprNo;
				const affrPrcsId = this.detailForm.affrPrcsId;
				const formData = this.detailFormData_;
				formData.set('pgsStCd', pgsStCd);
				formData.set('sndStCd', 'NSND');
				

				const { code, messageCd } = await this.saveState2_({ formData, pprNo, affrPrcsId, pgsStCd });
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					this.$emit('Close');
					code === 0 && this.$emit('Refresh');
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},

		/**
		 *  삭제 버튼 클릭시
		 */
		deleteAction() {
			try {
				// 유효성 체크
				this.makeValidatePprNo();
				const pgsStCd = Number(this.detailForm.pgsStCd);

				if(!(this.isButton_(this.scrId, 'CS') && (this.flgPqyapGrp || this.flgPqyrgGrp || this.flgPqyrvGrp)) && !this.flgOsGrp){
					const sessionUserId = window.atob(this.user.userId);
					if (this.detailForm.rgnId !== sessionUserId) {
						throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001509'))); // 작성자만 삭제가 가능합니다.
					}

				}

				if (pgsStCd !== undefined && pgsStCd > 20) {
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001635'))); // 현재 진행상태 에서는 삭제가 불가능합니다.
				}

				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('SWCC000554'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001136'), clickFn: () => this.deletePrtRpt() }] //삭제
				});
				// }
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async deletePrtRpt() {
			try {
				this.$sf_toggleLoading(true);
				const { pprNo, badFileId, badCausFileId, normImgFileId, badImgFileId } = this.detailForm;
				const delParams = {
					pprNo: pprNo,
					badFileId: badFileId,
					badCausFileId: badCausFileId,
					normImgFileId: normImgFileId,
					badImgFileId: badImgFileId
				};

				const { code, messageCd } = await this.deletePrtRpt_(delParams);
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});

					code === 0 && this.$emit('deleteFin', 'ok');
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		/**
		 *  회신 버튼 클릭시
		 */
		answerAction(pgsStCd) {
			try {
				// 유효성 체크
				this.makeValidatePprNo();

				// 회신은 승인상태(30)일 경우만 가능함
				const formPgsStCd = this.detailForm.pgsStCd;
				if (formPgsStCd !== '30') {
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001636'))); // 승인된 상태에서만 회신이 가능합니다.
				}

				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001592'), //회신처리 하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001571'), clickFn: () => this.answer(pgsStCd) }] //회신
				});
				// }
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async answer(pgsStCd) {
			try {
				this.$sf_toggleLoading(true);
				const pprNo = this.detailForm.pprNo;

				const formData = this.detailFormData_;
				formData.set('pgsStCd', pgsStCd);
				formData.set('sndStCd', 'NSND');
				// for (const [key, val] of Object.entries(this.detailForm)) {
				// 	if (key === 'badCausFile') {
				// 		val.length ? val.forEach(file => formData.append(key, file)) : formData.append(key, '');
				// 	}

				// 	if (
				// 		key === 'pprNo' ||
				// 		key === 'badCausSbc' ||
				// 		key === 'bttmMdvSbc' ||
				// 		key === 'badCausFileId' ||
				// 		key === 'bttmLotNo' ||
				// 		key === 'mdvDd' ||
				// 		key === 'rptpPrcsCd' ||
				// 		key === 'partGCd'
				// 	) {
				// 		console.log('key ::', key, val);
				// 		// if (!val) continue;
				// 		formData.append(key, val);
				// 	}
				// }

				const { code, messageCd } = await this.answer_({ formData, pprNo });
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});

					code === 0 && this.$emit('deleteFin', 'ok');
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		/**
		 *  개선이력 버튼 클릭시
		 */
		historyAction() {
			this.$emit('PprHistoryOpen', 'test');
		},
		/**
		 *  메일발송 버튼 클릭시
		 */
		mailSendAction() {
			try {
				// 유효성 체크
				//this.makeValidateMail();

				// 유효성 체크
				this.makeValidatePprNo();

				// this.onChangeParam_({ key: 'dsprNm', value: this.user.userName });
				// this.onChangeParam_({ key: 'dsprAdr', value: 'this.user.email' });
				// this.onChangeParam_({ key: 'dsprAdr', value: 'abc@asd.com' });
				//this.makeValidateEmailAdr();

				// if (this.detailForm.sndStCd !== 'SND_CMPL') {
				this.onChangeParam_({ key: 'sndStCd', value: 'NSND' });

				if (!this.detailForm.rmk) this.onChangeParam_({ key: 'rmk', value: 'User sent the email.' });
				// }

				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001483'), //메일을 발송하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001484'), clickFn: () => this.sendMail() }] //발송
				});
				// }
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async sendMail() {
			try {
				this.$sf_toggleLoading(true);
				// const { rcptNm, rcptAdr, rfpNm, rfpAdr, sndStCd, badSbc, badTitSbc, dsprAdr, dsprNm } = this.detailFormData_;
				// const sendData = {
				// 	sndStCd: sndStCd,
				// 	badTitSbc: badTitSbc,
				// 	badSbc: badSbc,
				// 	rcptNm: rcptNm,
				// 	rcptAdr: rcptAdr,
				// 	rfpNm: rfpNm,
				// 	rfpAdr: rfpAdr,
				// 	dsprNm: dsprNm,
				// 	dsprAdr: dsprAdr
				// };

				const fData = this.detailFormData_;

				const sendData = {
					pprNo: fData.get('pprNo'),
					sndStCd: fData.get('sndStCd'),
					badTitlSbc: fData.get('badTitlSbc'),
					badSbc: fData.get('badSbc'),
					rcptNm: fData.get('rcptNm'),
					rcptAdr: fData.get('rcptAdr'),
					rfpNm: fData.get('rfpNm'),
					rfpAdr: fData.get('rfpAdr'),
					dsprNm: fData.get('dsprNm'),
					dsprAdr: fData.get('dsprAdr')
				};

				const { code, messageCd } = await this.sendMail_({ sendData });
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		makeValidateSave() {
			let {
				partGCd,
				lotFromNo,
				lotToNo,
				badQty,
				badTypeSgrpCd,
				clmTypeCd,
				tpWayCd,
				abrdRprTm,
				badTitlSbc,
				badSbc,
				badImgFile,
				badImgFileDb,
				mdvRplCd,
				rplSbc,
				ckuQty
			} = this.detailForm;
			//KD와 LP일 경우 차이가 있다.
			if (partGCd === 'K') {
				if (utils.$sf_isNull(lotFromNo)) {
					// {0}는 필수입력 입니다. , lot번호(FR)
					throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001470')]));
				}
				if (utils.$sf_isNull(lotToNo)) {
					// {0}는 필수입력 입니다. , lot번호(TO)
					throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001469')]));
				}
//				if (!lotFromNo.startsWith('O')) {
					// {0}는 시작문자가 O로 시작되어야 합니다., lot번호(FR)
//					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001704'), [this.getMessage_('QWCC001470')]));
//				}
//				if (!lotToNo.startsWith('O')) {
					// {0}는 시작문자가 O로 시작되어야 합니다., lot번호(TO)
//					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001704'), [this.getMessage_('QWCC001469')]));
//				}
				if (lotFromNo.substr(0, 6) !== lotToNo.substr(0, 6)) {
					throw new TypeError(
						// 입력한 {0}과 {1} 의 앞 6자리가 동일해야 합니다.
						this.$sf_formatString(this.getMessage_('QWCC001705'), [this.getMessage_('QWCC001470'), this.getMessage_('QWCC001469')])
					);
				}

				if (utils.$sf_isNull(clmTypeCd)) {
					// {0}는 필수입력 입니다. , 클래임유형
					throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001664')]));
				} else {
					if (clmTypeCd === 'A') {
						if (utils.$sf_isNull(tpWayCd) || tpWayCd === '') {
							// {0}는 필수입력 입니다. , 운송수단
							throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001665')]));
						}
					} else {
						if (utils.$sf_isNull(abrdRprTm) || abrdRprTm === '') {
							// {0}는 필수입력 입니다. , 해외수리시간
							throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001667')]));
						}
					}
				}
			} else {
				//LP일 경우 시작
				if (utils.$sf_isNull(mdvRplCd) || mdvRplCd === '') {
					// {0}는 필수입력 입니다. , 대책 회신
					throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001436')]));
				}

				//대책회신이 불필요일 경우 내용을 필수입력해야 한다.
				if (mdvRplCd === 'RPL20') {
					if (utils.$sf_isNull(rplSbc) || rplSbc === '') {
						// {0}는 필수입력 입니다. , 회신불필요 내용
						throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001819')]));
					}
				}
			}

			//공통 적용 시작
			if (utils.$sf_isNull(badTitlSbc) || badTitlSbc === '') {
				// {0}는 필수입력 입니다. , 제목
				throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001438')]));
			}

			if (utils.$sf_isNull(badSbc) || badSbc === '') {
				// {0}는 필수입력 입니다. , 불량내용
				throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001387')]));
			}

			if (utils.$sf_isNull(ckuQty) || Number(ckuQty) === 0) {
				// {0}는 필수입력 입니다. , 검사수량
				throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000073')]));
			}

			if (utils.$sf_isNull(badQty) || Number(badQty) === 0) {
				// {0}는 필수입력 입니다. , 불량수량
				throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000074')]));
			}

			if (Number(badQty) > Number(ckuQty)) {
				// 불량수량은 검사수량보타 입력값이 클 수 없습니다.
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC002057')));
			}

			if (utils.$sf_isNull(badTypeSgrpCd)) {
				// {0}는 필수입력 입니다. , 결함유형
				throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001468')]));
			}

			if (utils.$sf_isNull(badTitlSbc)) {
				// {0}는 필수입력 입니다. , 제목
				throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001438')]));
			}

			// if (utils.$sf_isNull(ckuQty)) {
			// 	// {0}는 필수입력 입니다. , 검사수량
			// 	throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000073')]));
			// }

			// if (utils.$sf_isNull(badQty)) {
			// 	// {0}는 필수입력 입니다. , 불량수량
			// 	throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000074')]));
			// }

			if (utils.$sf_isNull(badSbc)) {
				// {0}는 필수입력 입니다. , 내용
				throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001387')]));
			}

			if (utils.$sf_isNull(badImgFile) && utils.$sf_isNull(badImgFileDb)) {
				// {0}는 필수입력 입니다. , 불량품(필수)
				throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001963')]));
			}
		},
		makeValidatePprNo() {
			let pprNo = this.detailForm.pprNo;
			if (pprNo === undefined || pprNo === '') {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001584'))); // 조회된 불량보고서 번호가 없습니다.
			}
		},
		makeValidateState(btnPsgStCd) {
			let formPgsStCd = this.detailForm.pgsStCd;
			const mdvRplCd = this.detailForm.mdvRplCd; //대책회신
			const partGCd = this.detailForm.partGCd; //
			if (formPgsStCd === undefined || formPgsStCd === null) {
				formPgsStCd = '';
			}

			// 반려버튼 클릭시
			// if (partGCd === 'K') {
			// 	if (btnPsgStCd === '10' && (formPgsStCd === '20' || formPgsStCd === '30')) {
			// 		// 작성, 승인 상태에서만 반려가능
			// 		throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001641'))); // 반려가 불가능한 상태입니다.
			// 	}
			// } else {
			// 	if (btnPsgStCd === '10' && !(formPgsStCd === '30' || formPgsStCd === '40')) {
			// 		// 작성, 회신 상태에서만 반려가능
			// 		throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001641')) + '123'); // 반려가 불가능한 상태입니다.
			// 	}
			// }

			let rmk = this.detailForm.rmk1;
			if (rmk === undefined || rmk === null) {
				rmk = '';
			}
			// if (btnPsgStCd === '10' && formPgsStCd === '20' && rmk === '') {
			// 	//throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001642'))); // 승인자의 반려사유는 필수입력입니다.
			// 	throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000906')])); //  //{0}은(는) 필수 입력 값 입니다. , 비고
			// }
			// if (btnPsgStCd === '10' && formPgsStCd === '40' && rmk === '') {
			// 	// throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001643'))); // 결재자의 반려사유는 필수입력입니다.
			// 	throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000906')])); //  //{0}은(는) 필수 입력 값 입니다. , 비고
			// }

			// 작성버튼 클릭시
			if (btnPsgStCd === '20' && formPgsStCd !== '' && Number(formPgsStCd) > 20) {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001584'))); // 작성만 가능합니다.
			}

			// 승인버튼 클릭시
			if (btnPsgStCd === '30' && formPgsStCd !== '20') {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001637'))); // 작성상태에서만 승인이 가능합니다.
			}

			// Glims 전용인지 확인
			if (this.isGlims === true) {
				//확정 버튼 클릭시
				if (btnPsgStCd === '40' && formPgsStCd !== '30') {
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001640'))); // 승인상태에서만 확정이 가능합니다.
				}
			} else {
				if (mdvRplCd === 'RPL10') {
					//대책회신이 회신필요일 때만 적용
					// 회신버튼 클릭시
					if (btnPsgStCd === '40' && formPgsStCd !== '30') {
						throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001638'))); // 승인상태에서만 회신이 가능합니다.
					}

					// 확정버튼 클릭시
					if (btnPsgStCd === '50' && formPgsStCd !== '40') {
						throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001639'))); // 회신상태에서만 확정이 가능합니다.
					}
				} else {
					//회신 불필요 일 경우 일반적인 패턴 적용
					// 승인버튼 클릭시
					if (!(btnPsgStCd === '50' && formPgsStCd === '40')) {
						throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001640'))); // 승인상태에서만 확정이 가능합니다.
					}
				}
			}

			// let formPgsStCd = this.detailForm.pgsStCd;
			// if(pgsStCd >= formPgsStCd){

			// }
		},
		makeValidateEmailAdr() {
			// let dsprNm = this.detailForm.dsprNm;
			// let dsprAdr = this.detailForm.dsprAdr;
			const { dsprNm, dsprAdr, rcptNm, rcptAdr, rfpNm, rfpAdr } = this.detailForm;
			if (dsprNm === undefined || dsprNm === '' || dsprAdr === undefined || dsprAdr === '' || dsprAdr === null) {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001496'))); // 메일 발신자를 입력해주시기 바랍니다.
			}

			if (utils.$sf_isNull(rcptAdr)) {
				throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001460')])); // {0}는 필수입력 입니다. , 조치처
			}

			// if (utils.$sf_isNull(rfpAdr)) {
			// 	throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001461')])); // {0}는 필수입력 입니다. , 참조처
			// }
		},
		makeValidateMail() {
			let { rcptNm, rcptAdr, rfpNm, rfpAdr, dsprNm, dsprAdr } = this.detailForm;
			//조치처
			if (rcptNm.split(';').length !== rcptAdr.split(';').length) {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001481'))); // 입력된 조치처 명의 갯수와, 이메일의 갯수가 다릅니다.
			}
			if (rcptNm === '' || rcptAdr === '') {
				throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001460')])); // {0}는 필수입력 입니다. , 조치처
			}

			// 참조처
			if (rfpNm.split(';').length !== rfpAdr.split(';').length) {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001482'))); // 입력된 참조처 명의 갯수와, 이메일의 갯수가 다릅니다.
			}
			if (rfpNm === '' || rfpAdr === '') {
				throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001461')])); // {0}는 필수입력 입니다. , 참조처
			}

			// 발신처
			if (dsprNm === '' || dsprAdr === '') {
				throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000050')])); // {0}는 필수입력 입니다. , 발신처
			}
		},

		//레포트 출력
		async reportAction() {
			const langCd = this.langCd;
			const apcn =
				'apcn#"' +
				(this.detailForm.affrDspoNm1 || ' - ') +
				'^t' +
				(this.detailForm.affrDspoNm2 || ' - ') +
				'^t' +
				(this.detailForm.affrDspoNm3 || ' - ') +
				'^t' +
				(this.detailForm.affrPrcsDt1 || ' - ') +
				'^t' +
				(this.detailForm.affrPrcsDt2 || ' - ') +
				'^t' +
				(this.detailForm.affrPrcsDt3 || ' - ') +
				'"';
			const basicInfo =
				'#basicInfo#"' +
				(this.detailForm.pprNo || ' - ') +
				'^t' +
				(this.detailForm.ckuNo || ' - ') +
				'^t' +
				(this.detailForm.overSrgNo || ' - ') +
				'^t' +
				(this.$moment(this.detailForm.occuDd).format('YYYY-MM-DD') || ' - ') +
				'^t' +
				(this.detailForm.partNo || ' - ') +
				'^t' +
				(this.detailForm.partNm || ' - ') +
				'^t' +
				(this.detailForm.lotFromNo || ' - ') +
				'^t' +
				(this.detailForm.lotToNo || ' - ') +
				'^t' +
				(this.detailForm.badQty || ' - ') +
				'^t' +
				(this.detailForm.occuPlNm || ' - ') +
				'^t' +
				(this.detailForm.partGNm || ' - ') +
				'^t' +
				(this.detailForm.cofNm || ' - ') +
				'"';
			const status =
				'#status#"' +
				(this.detailForm.badTitlSbc || ' - ') +
				'^t' +
				(this.detailForm.badSbc || ' - ') +
				'^t' +
				(this.getPictureUrl(this.detailForm.normImgFileDb) || ' - ') +
				'^t' +
				(this.getPictureUrl(this.detailForm.badImgFileDb) || ' - ') +
				'"';
			this.$refs.reportPopup.openWindowReport({
				ubiTarget: this.ubiTarget,
				jrfName: `ngInform_${langCd}.jrf`,
				streamdata: apcn + basicInfo + status
			});
		},
		getPictureUrl(picDb) {
			if (picDb?.uploadPath && picDb?.saveFileName) {
				const idx = picDb.uploadPath.lastIndexOf('attachment') + 'attachment'.length;
				const imgPath = this.feTarget + 'fimages' + picDb.uploadPath.substring(idx, picDb.uploadPath.length) + '/' + picDb.saveFileName;
				return imgPath.replaceAll('\\', '/'); //역슬러시는 pdf 또는 인쇄물에서서 안나와서 바꿔주는 작업 필요
			}
			return ' ';
		}
	}
};
</script>

<style></style>
